import { render } from "./qgThreeInOne.vue?vue&type=template&id=6b45325a&scoped=true"
import script from "./qgThreeInOne.vue?vue&type=script&lang=js"
export * from "./qgThreeInOne.vue?vue&type=script&lang=js"

import "./qgThreeInOne.vue?vue&type=style&index=0&id=6b45325a&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b45325a"]])

export default __exports__